import TreeContainer from "../../../Components/BonusUi/Tree/TreeContainer";

const Tree = () => {
  return <TreeContainer />;
};

export default Tree;
